// extracted by mini-css-extract-plugin
module.exports = {"productCarousel":"pi-z","itemsContainer":"qi-z"};